export const validateCarrier = (record) => {
  const {
    account_name,
    key,
    is_batch_shipping,
    meter_password,
    mode,
  } = record?.carrier_api_credential ?? {};

  const errors = {};

  if (!account_name) errors.account_name = 'Please enter account number';
  if (!key) errors.key = 'Please enter key';
  if (!meter_password) errors.key = 'Please enter password';
  if (!is_batch_shipping === '') errors.is_batch_shipping = 'Please enter value';
  if (!mode === '') errors.mode = 'Please enter mode';

  return errors;
};

export const validateFedex = (record) => {
  const {
    account_name,
    key,
    is_batch_shipping,
    meter,
    secret_key,
    mode,
  } = record?.carrier_api_credential ?? {};

  const errors = {};

  if (!account_name) errors.account_name = 'Please enter account number';
  if (!key) errors.key = 'Please enter key';
  if (!secret_key) errors.key = 'Please enter secret key';
  if (is_batch_shipping === '') errors.is_batch_shipping = 'Please enter value';
  if (!meter) errors.meter = 'Please enter meter';
  if (mode === '') errors.mode = 'Please enter mode';

  const {
    account_number: sm_account_number,
    meter: sm_meter,
  } = record?.carrier_api_fedex_smart_post_credential ?? {};

  errors.carrier_api_fedex_smart_post_credential = {};

  if (!sm_account_number) errors.account_number = 'Please enter account number';
  if (!sm_meter) errors.carrier_api_fedex_smart_post_credential.meter = 'Please enter meter';

  const {
    key: tracking_key,
    secret_key: tracking_secret_key,
    account_name: tracking_account_name,
  } = record?.carrier_tracking_api_credential ?? {};

  errors.carrier_tracking_api_credential = {};

  if (!tracking_key) errors.carrier_tracking_api_credential.key = 'Please enter key';
  if (!tracking_secret_key) errors.carrier_tracking_api_credential.secret_key = 'Please enter secret key';
  if (!tracking_account_name) errors.carrier_tracking_api_credential.account_name = 'Please enter account number';

  return errors;
};
